var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.display)?_c('div',{staticClass:"alert",class:_vm.model.coupon.isValid ? 'alert-success' : 'alert-danger'},[_vm._v("\n        "+_vm._s(_vm.model.coupon.string)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6d2f22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modules/Coupon.vue
// module id = +8R5
// module chunks = 0